export const SERVICE_AREA_TYPES = {
  NATIONAL: 'national',
  STATE: 'state'
};
export const SEARCH_ROLES = {
  PAYMENTS: 'payments'
};
export const SCROLL_TO = {
  SERVICE_TYPES_SCROLL_POSITION: 'SERVICE_TYPES_SCROLL_POSITION',
  DESCRIPTION_SCROLL_POSITION: 'DESCRIPTION_SCROLL_POSITION'
};
//# sourceMappingURL=constants.js.map